import { createAction } from '@reduxjs/toolkit'

export const resetComposer = createAction('posts/resetComposer')
